import Rank from "../pages/Rank";
import Home from "../pages/Home";
import Order from "../pages/Order";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";

export const navigation_data = [
    { name: "Others", path: "/others", icon: "fa fa-star", component: <Home/>, protected: true , is_tabbar: false  },
    { name: "Home", path: "/", icon: "fa fa-home", component: <Rank/>, protected: true, is_tabbar: true  },
    { name: "Order", path: "/order", icon: "fa fa-truck", component: <Order/>, protected: true, is_tabbar: true  },
    { name: "SignIn", path: "/sign-in", icon: "fa fa-truck", component: <SignIn/>, protected: false, is_tabbar: false  },
    // { name: "SignUp", path: "/", icon: "fa fa-truck", component: <SignUp/> },
    // { name: "About", path: "/about", icon: "fa fa-info-circle" },
];